import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { QResult, SelectList } from '../models';
import { CoreService, HttpService } from '../services';

@Component({
  selector: 'q-produit-action',
  templateUrl: './produit-action.component.html',
  styleUrls: ['./produit-action.component.css']
})
export class ProduitActionComponent implements OnInit {

  constructor(
    private http: HttpService,
    private indparam: CoreService,
  ) { }

  public catalogueAndFormation: any;
  catergorieOrAction: Array<SelectList>;
  produitOrSession: Array<SelectList>;


  firstSelection: any;
  secondSelection: any;
  thirdSelection: any;


  secondSelectionTitle: string = 'Sélectionner une catégorie ou formation';
  thirdSelectionTitle: string = 'Sélectionner un produit ou action';

  @Output() selectedElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() set element(value: string) {
    this.inputElement$.next(value);
  }

  produit$: Observable<any>;
  action$: Observable<any>;
  inputElement$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  catalogueAndFormation$: Observable<any>;

  elementType: string;

  ngOnInit(): void {

    this.produit$ = this.http.getHttp<QResult<Array<SelectList>>>(`${this.indparam.AppParams.apiUrl}api/Stage/Display/GET_CATALOGUES_CATEGORIES_PRODUITS/0`).pipe(map(catalogue => {
      return catalogue.Value.map((x: SelectList) => { return { type: 'catalogue', ...x }; });
    }));

    this.action$ = this.http.getHttp<QResult<Array<SelectList>>>(`${this.indparam.AppParams.apiUrl}api/Stage/Display/GET_OFFRES_FORMATIONS_ACTIONS/0`).pipe(map(formation => {
      return formation.Value.map((x: SelectList) => { return { type: 'offre', ...x }; });
    }));

    this.catalogueAndFormation$ = forkJoin([this.produit$, this.action$]).pipe(map(fork => {

      let result = [];
      if (fork[0].length > 0)
        result.push({ type: 'Catalogues', listSelect: fork[0] });
      if (fork[1].length > 0)
        result.push({ type: 'Offres', listSelect: fork[1] });
  
      return result;
    }));
    
    combineLatest([this.catalogueAndFormation$, this.inputElement$]).subscribe(([comboValue, ident]) => {
      this.catalogueAndFormation = comboValue;

      if (!ident) {
        this.firstSelection = this.secondSelection = this.thirdSelection = undefined;
        return;
      }

      let listIdent = ident.split('|')
      this.elementType = listIdent.shift()!;

      const setSelectedValue = (selectedIds: Array<string>, selectLists: Array<SelectList>, step: number = 3) => {
        if (selectedIds.length <= 0) return;

        const id = selectedIds.shift()!
        const selectedElement: any = selectLists.find((x: any) => { return x.id == id });
        switch (step) {
          case 3:
            this.firstSelection = selectedElement;
            this.catergorieOrAction = this.firstSelection.ListSelect;
            break;
          case 2: this.secondSelection = selectedElement;
            this.produitOrSession = this.secondSelection.ListSelect;
            break;
          case 1: this.thirdSelection = selectedElement; break;
        }
        setSelectedValue(selectedIds, selectedElement.ListSelect, step - 1);
      }

      setSelectedValue(listIdent, this.catalogueAndFormation.flatMap((a: any) => a.listSelect));
    });
  }

  //change 1er combo
  public onChangeCatalogueFormation() {
    this.secondSelection = this.thirdSelection = undefined;
    if (this.firstSelection) {
      this.elementType = this.firstSelection.type;
      this.catergorieOrAction = this.firstSelection.ListSelect;

      if (this.firstSelection.type == 'catalogue') {
        this.secondSelectionTitle = "Sélectionner une catégorie";
        this.thirdSelectionTitle = "Sélectionner un produit";
      } else {
        this.secondSelectionTitle = "Sélectionner une formation";
        this.thirdSelectionTitle = "Sélectionner une action";
      }
    } else {
      this.secondSelectionTitle = "Sélectionner une catégorie ou formation";
      this.thirdSelectionTitle = "Sélectionner un produit ou action";
    }


    this.emit(this.firstSelection);
  }

  //change 2eme combo
  public onChangeCategorieAction() {
    this.thirdSelection = undefined;

    if (!this.secondSelection) {
      this.emit(this.firstSelection);
      return;
    }

    this.elementType = this.firstSelection.type == 'catalogue' ? 'categorie' : 'formation';
    this.produitOrSession = this.secondSelection.ListSelect;
    this.emit(this.secondSelection);
  }

  //change 3eme combo
  public onChangeProduitSession() {
    if (!this.thirdSelection) {
      this.emit(this.secondSelection);
      return;
    }


    this.elementType = this.firstSelection.type == 'catalogue' ? 'produit' : 'action';
    this.emit(this.thirdSelection);
  }


  emit(element: any) {
    const emitValue: any = { ...element, type: this.elementType };
    emitValue.id = [this.firstSelection?.id, this.secondSelection?.id, this.thirdSelection?.id].filter(x => x != undefined).join('|');
    this.selectedElement.emit(emitValue);
  }
}
